<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box no-display">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Meal Report</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
              @change="getInstallmentData()"
            />
          </v-col>
          <v-col sm="2" cols="12" v-if="canteen_installment_list != ''">
            <p><v-icon color="error">*</v-icon><b>Canteen Installment</b></p>
            <v-autocomplete
              rounded
              dense
              required
              v-model="canteen_installment"
              :items="canteen_installment_list"
              item-text="name"
              item-value="id"
              label="Canteen Installment"
              outlined
              persistent-hint
              hint="Please Select Installment"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" v-if="canteen_installment_list != ''">
            <p><v-icon color="error">*</v-icon><b>Section</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="section"
              :items="section_list"
              item-text="name"
              item-value="id"
              label="Section"
              @change="getStandardBySection()"
              outlined
              persistent-hint
              hint="Please Select Section"
            />
          </v-col>
          <v-col cols="12" sm="2" v-if="this.standard_list != ''">
            <p><v-icon color="error">*</v-icon><b>Standard</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="standard"
              :items="standard_list"
              item-text="standard"
              item-value="id"
              label="Standard"
              outlined
              persistent-hint
              hint="Please Select Standard"
              multiple
            />
          </v-col>
          <!-- <v-col cols="12" sm="2" v-if="this.division_offering_list.length > 0">
            <p><v-icon color="error">*</v-icon><b>Division</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="division"
              :items="division_offering_list"
              item-text="division"
              item-value="id"
              label="Division"
              outlined
              persistent-hint
              hint="Please Select Division"
            />
          </v-col> -->

          <v-col cols="12" sm="2" class="pt-4" v-if="standard_list != ''">
            <br />
            <v-btn color="primary" @click="getMealReportData()">Fetch</v-btn>
          </v-col>
        </v-row>
        <!-- <hr><br> -->
        <!-- <v-row justify="center" dense>
        <h3>OR</h3>
        </v-row>
         <v-row justify="center" dense>
            <v-col cols="12" sm="3">
            <p><b>Date</b></p>
            <v-text-field
              outlined
              dense
              type="date"
              v-model="fromdate"
            ></v-text-field>
          </v-col>
           <v-col cols="12" sm="2" class="pt-4" v-if="fromdate">
            <br />
            <v-btn
              color="primary"
              @click="getMealReportDateWise()"
              >Fetch</v-btn
            >
          </v-col>
        </v-row> -->
      </v-card>

      <v-card class="box" v-if="this.learner_list != ''">
        <v-toolbar class="toolbar no-display" flat dense>
          <v-toolbar-title>
            <strong> Canteen Daily Meal Report </strong>
          </v-toolbar-title> </v-toolbar
        ><br />
        <v-row class="no-display" dense v-if="headers_list_size != ''">
          <!-- export btn code -->
          <v-col cols="12" sm="6" md="3">
            <v-btn
              rounded
              color="success"
              outlined
              @click="fnExcelReport('my-table-id', 'MealReport')"
              ><v-icon color="success">mdi-export</v-icon>Export</v-btn
            >
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <v-btn
              class="ma-2 no-display"
              tile
              outlined
              color="warning"
              @click="print1()"
            >
              <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-btn
              class="ma-2 no-display"
              tile
              outlined
              color="warning"
              @click="showLogo()"
            >
              Hide /Show Logo
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-checkbox v-model="remark" label="Remark "></v-checkbox>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-checkbox
                  v-model="print_receipt"
                  label="Print Receipt "
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div id="my-table-id">
          <!-- header code shiv -->
          <v-simple-table></v-simple-table>
          <div v-if="org_basic_data">
            <v-row dense justify="center">
              <v-col
                cols="12"
                sm="4"
                md="2"
                v-if="org_basic_data.trust_logo && show_logo"
                align="center"
              >
                <img
                  :src="org_basic_data.trust_logo"
                  alt="logo"
                  class="trust-logo"
                />
              </v-col>
              <v-col cols="12" sm="4" md="8">
                <center>
                  <h2>
                    <strong>{{ org_basic_data.trust_name }}</strong>
                  </h2>
                  <h3>
                    <strong>{{ org_basic_data.school_name }} </strong>
                  </h3>
                  <span>{{ org_basic_data.address }}</span> <br />
                  <span>Phone :{{ org_basic_data.phone }} </span> <br />
                  <span>Email :{{ org_basic_data.email }} </span> <br />
                  <span>Website :{{ org_basic_data.website }} </span>
                  <br />
                </center>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="2"
                v-if="org_basic_data.school_logo && show_logo"
              >
                <img
                  :src="org_basic_data.school_logo"
                  alt="logo"
                  class="schl-logo"
                />
              </v-col>
            </v-row>
          </div>
          <div>
            <center>
              <b> <span>Meal Report </span></b>
            </center>
          </div>
          <v-simple-table
            class="elevation-1 mytable"
            v-if="headers_list_size != ''"
          >
            <template>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>PRN</th>
                  <th>Contact</th>
                  <th>Standard</th>
                  <th>Division</th>
                  <th>Joining Date</th>
                  <th
                    :colspan="headers_list_size"
                    v-for="(item, index) in headers_list"
                    :key="index"
                  >
                    {{ item }}
                  </th>
                  <th>Active/In-active</th>
                  <th v-if="remark">Remarks</th>
                  <th v-if="print_receipt">Receipts</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th v-for="(item1, index) in sub_header_list" :key="index">
                    {{ item1 }}
                  </th>
                  <th v-if="is_blocked_for_canteen"></th>
                  <th v-if="remark"></th>
                  <th v-if="print_receipt"></th>
                </tr>
                <tr v-for="(item, index) in learner_list" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.mobile_no }}</td>
                  <td>{{ item.standard }}</td>
                  <td>{{ item.division }}</td>
                  <td>{{ item.joining_date }}</td>
                  <td v-for="(a, index1) in item.amount" :key="index1">
                    {{ a }}
                  </td>
                  <td>{{ item.is_blocked_for_canteen }}</td>
                  <td v-if="remark">
                    <span v-if="item.blocked_for_canteen_reason">
                      {{ item.blocked_for_canteen_reason }}
                    </span>
                    <span v-else> -- </span>
                  </td>
                  <td v-if="print_receipt">
                    <span v-for="item in item.receipt_no" :key="item">
                      <v-tooltip top color="warning">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mt-1 mb-1"
                            rounded
                            outlined
                            small
                            color="warning"
                            v-bind="attrs"
                            v-on="on"
                            @click="print(item, item.ay)"
                          >
                            <v-icon color="warning">mdi-printer</v-icon
                            >{{ item }}</v-btn
                          >
                        </template>
                        <span> Print Fee Receipt!!! </span>
                      </v-tooltip>
                    </span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    ay_list: [],
    ay: "",
    section_list: [],
    section: "",
    standard_list: [],
    standard: "",
    division_offering_list: [],
    div_off: "",
    overlay: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    canteen_installment_list: [],
    canteen_installment: "",
    fromdate: new Date().toISOString().slice(0, 10),
    headers_list: [],
    sub_header_list: [],
    headers_list_size: [],
    learner_list: [],
    remark: true,
    print_receipt: true,
    org_basic_data: [],
    show_logo: true,
  }),
  watch: {},
  methods: {
    showLogo() {
      if (this.show_logo) {
        this.show_logo = false;
      } else {
        this.show_logo = true;
      }
    },
    print1() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    print(receipt_no, ay) {
      this.receipt_no = receipt_no;
      this.$session.set("receipt_no", JSON.stringify(receipt_no));
      this.$session.set("ay", JSON.stringify(ay));
      let routeData = this.$router.resolve({ name: "canteen-receipt" });
      window.open(routeData.href, "_blank");
    },
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    getMealReportData() {
      this.headers_list = [];
      this.sub_header_list = [];
      this.learner_list = [];
      this.headers_list_size = "";
      const data = {
        ay: this.ay,
        standard: this.standard,
        canteen_installment: this.canteen_installment,
      };
      this.overlay = true;
      axios
        .post("/Canteen/getMealReportData", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.flag == "YES") {
            this.learner_list = res.data.learner_list;
            if (this.learner_list.length == 0) {
              this.showSnackbar("#b71c1c", "No Records Found..."); // show snackbar
              return;
            }
            this.headers_list = res.data.headers_list;
            this.sub_header_list = res.data.sub_header_list;
            this.headers_list_size = res.data.headers_list_size;
            this.org_basic_data = res.data.org_basic_data;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getMealReportDateWise() {
      const data = {
        date: this.fromdate,
      };
      this.overlay = true;
      axios
        .post("/Canteen/getMealReportDateWise", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.flag == "YES") {
            this.learner_list = res.data.learner_list;
            if (this.learner_list.length == 0) {
              this.showSnackbar("#b71c1c", "No Records Found..."); // show snackbar
              return;
            }
            this.headers_list = res.data.headers_list;
            this.sub_header_list = res.data.sub_header_list;
            this.headers_list_size = res.data.headers_list_size;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    getInstallmentData() {
      const data = {
        ay: this.ay,
      };
      this.overlay = true;
      axios
        .post("/Canteen/getCanteenInstallmentList", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.flag == "YES") {
            this.canteen_installment_list = res.data.canteen_installment_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getDivOffByStandard() {
      const data = {
        section: this.section,
        ay: this.ay,
        standard: this.standard,
      };
      axios
        .post("/AccountingAndFees/getDivOffByStandard", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.division_offering_list = res.data.division_offering_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.onerror(error);
        })
        .finally(() => {});
    },
    getStandardBySection() {
      const data = {
        section: this.section,
      };
      axios
        .post("/AccountingAndFees/getStandardBySection", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.standard_list = res.data.standard_list;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.onerror(error);
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    onLoad() {
      axios
        .post("AccountingAndFees/getReceipts")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list),
              //(this.ay = res.data.curreny_ay);
              (this.section_list = res.data.section_list);
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
    this.selected_date = this.formatDate(this.date);
  },
  //   computed: {
  //     filteredItems() {
  //       return this.student_receipt_details.filter((item) => {
  //         return (
  //           item.name.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 ||
  //           item.registration_number
  //             .toLowerCase()
  //             .indexOf(this.search1.toLowerCase()) > -1
  //         );
  //       });
  //     },
  //   },
};
</script>
<style scoped>
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}

.trust-logo {
  width: 86%;
}
.schl-logo {
  width: 86%;
}
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  img {
    width: 100% !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  .box {
    background-color: white !important;
    border: none !important;
  }

  @page {
    size: A4;
    margin-top: none !important;
    padding-top: none;
    /* size: 16in 17in; */
    size: 17in 17in;
  }
}
</style>
